











































































































































import Vue from "vue";
import { mapGetters } from "vuex";
import moment from "moment";

import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { GetUsersStatisticsCommand } from "@/model/communication/platformMaintenance/GetUsersStatisticsCommand";
import { GetUsersStatisticsResData } from "@/model/communication/platformMaintenance/GetUsersStatisticsResData";
import { DeleteClientProfileCommand } from "@/model/communication/users/DeleteClientProfileCommand";
import { DeleteClientProfileReqData } from "@/model/communication/users/DeleteClientProfileReqData";
import { DeleteClientUserCommand } from "@/model/communication/users/DeleteClientUserCommand";
import { DeleteClientUserReqData } from "@/model/communication/users/DeleteClientUserReqData";

export default Vue.extend({
    data() {
        return {
            moment,
            totalUsers: 0,
            totalProfiles: 0,
            mau: 0,
            dau: 0,
            emptyProfiles: [],
            inactiveUsers: [],
            deleteProfileLoading: false,
            profileLoading: false,
            usersLoading: false,
            deleteUserLoading: false,
        };
    },
    computed: {
        ...mapGetters(["isUserSuperAdmin", "longDateFormat"]),
        emptyProfilesTextColor() {
            if (this.emptyProfiles.length == 0) return "success--text";
            else if (this.emptyProfiles.length < 2) return "warning--text";
            else return "error--text";
        },
        inactiveUsersTextColor() {
            if (this.inactiveUsers.size == 0) return "success--text";
            else if (this.inactiveUsers.size < 2) return "warning--text";
            else return "error--text";
        },
        emptyProfilesIcon() {
            if (this.emptyProfiles.length == 0) return "thumbs-up";
            else if (this.emptyProfiles.length < 2) return "exclamation-circle";
            else return "exclamation-triangle";
        },
        inactiveUsersIcon() {
            if (this.inactiveUsers.size == 0) return "thumbs-up";
            else if (this.inactiveUsers.size < 2) return "exclamation-circle";
            else return "exclamation-triangle";
        },
    },
    methods: {
        async sendRequest() {
            this.profileLoading = true;
            try {
                let res: GetUsersStatisticsResData = await new GetUsersStatisticsCommand().execute();
                if (res.responseStatus == ApiResponseStatusEnum.Success) {
                    this.totalUsers = res.totalUsers;
                    this.totalProfiles = res.totalProfiles;
                    this.mau = res.monthlyActiveUsers;
                    this.dau = res.dailyActiveUsers;
                    this.emptyProfiles = res.emptyProfiles;
                    this.inactiveUsers = res.inactiveUsers;
                }
            } catch (error) {
                console.error("error in GetUsersStatistics, exc: ", error);
            }
            this.profileLoading = false;
        },
        deleteProfile(profileName) {
            this.sendRequestDeleteProfile(profileName);
        },
        async sendRequestDeleteProfile(profileName) {
            this.deleteProfileLoading = true;
            try {
                let res = await new DeleteClientProfileCommand(new DeleteClientProfileReqData(profileName)).execute();
                if (res.responseStatus == ApiResponseStatusEnum.Success) {
                    this.sendRequest();
                }
            } catch (error) {
                console.error("error in DeleteClientProfile, exc: ", error);
            }
            this.deleteProfileLoading = false;
        },
        deleteUser(userName) {
            this.sendRequestDeleteUser(userName);
        },
        async sendRequestDeleteUser(userName) {
            this.deleteProfileLoading = true;
            try {
                let res = await new DeleteClientUserCommand(new DeleteClientUserReqData(userName)).execute();
                if (res.responseStatus == ApiResponseStatusEnum.Success) {
                    this.sendRequest();
                }
            } catch (error) {
                console.error("error in DeleteClientProfile, exc: ", error);
            }
            this.deleteProfileLoading = false;
        },
    },
    mounted() {
        this.sendRequest();
    },
});
